import FAQItem from './FAQItem'

import { faq } from '../../../constants'

const FAQ = () => {
  const faqContent = faq.map((question, index) => {
    return <FAQItem key={`faq-${index}`} question={question} />
  })

  return (
    <div className="w-full pt-[48px] pb-[120px] bg-[#F38548]">
      <div className="max-w-[768px] w-full mx-auto flex flex-col items-center">
        <h2 className="text-[36px] leading-[44px] font-semibold text-[#FDFDFD] text-center">
          Frequently Asked Questions
        </h2>

        <h3 className="mt-[20px] text-xl leading-[30px] text-[#FDFDFD]">
          Everything you need to know about APOLO P2P.
        </h3>

        <div className="mt-[64px] w-full flex flex-col items-start gap-y-[16px]">{faqContent}</div>
      </div>
    </div>
  )
}

export default FAQ
